import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from '../queries/queryKeys';

const onBindDocsDelete = async (value) => {
  return await request.delete(
    '/Docs/bind',
    value,
    'При отвязывание документа произошла ошибка',
    'Error'
  );
};

const useDocsBindDelete = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(onBindDocsDelete, {
    onSuccess: async (data, { documentId, bindEntityId }) => {
      if (data === 'Error') return;

      queryClient.invalidateQueries(queryKeys.bindByDocs(documentId));
    },
  });

  return {
    isLoading: mutation.isLoading,
    onBindDocsDelete: mutation.mutateAsync,
  };
};

export default useDocsBindDelete;
